import { Center, Flex, Link, Text, VStack } from '@chakra-ui/react';
import { useCheckoutConfigContext } from '@contexts/CheckoutConfig';
import { FormValues } from '@types';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const ThankYouPage: FC = () => {
  const { checkout } = useCheckoutConfigContext();
  const { t } = useTranslation();
  const { getValues } = useFormContext<FormValues>();

  return (
    <Center
      h="full"
      w="full"
      backgroundImage="linear-gradient(to bottom right, #e3e3e3, #ffffff)"
      p={{ base: 0, lg: 20 }}
    >
      <Flex
        h={{ base: 'full', lg: 'auto' }}
        backgroundColor="white"
        w="full"
        maxW={{ base: 'xl', lg: 'lg' }}
        px={{ base: 4, lg: 10 }}
        py={{ base: 4, lg: 8 }}
        overflow="auto"
        borderRadius="lg"
        direction="column"
        align="center"
        flexGrow={1}
      >
        <VStack w="full" h="full" justifyContent="center" alignItems="center">
          <Text fontWeight="bold" fontSize="xl" color="blackAlpha.800">
            {t('Your donation has been received!')}
          </Text>
          <Text fontSize="md">{t(`Thank you ${getValues('firstName')}!`)} ❤️</Text>

          <VStack pt={10}>
            <Link color="primary.500" href={checkout.campaign.sitefront_url}>
              {`${t('Back to')} ${checkout.campaign.title}`}
            </Link>
          </VStack>
        </VStack>
      </Flex>
    </Center>
  );
};

export default ThankYouPage;
